import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import toast from '@helpers/toast';

import { fetchShipmentByIdApi, fetchShipmentsApi, saveShipmentApi, shipShipmentApi } from './shipments.api';
import {
  fetchShipmentByIdFailure,
  fetchShipmentByIdRequest,
  fetchShipmentByIdSuccess,
  fetchShipmentsFailure,
  fetchShipmentsRequest,
  fetchShipmentsSuccess,
  saveShipmentFailure,
  saveShipmentRequest,
  saveShipmentSuccess,
  shipShipmentFailure,
  shipShipmentRequest,
  shipShipmentSuccess,
} from './shipments.slice';

import { Shipment } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchStoneShipmentsSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response: { items: Shipment[]; totalCount: number } = yield call(fetchShipmentsApi, action.payload);
    yield put(fetchShipmentsSuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchShipmentsFailure, 'Failed to load shipments');
  }
}

function* fetchShipmentByIdSaga(action: PayloadAction<number | string>): Generator<any, void, any> {
  try {
    const response: Shipment = yield call(fetchShipmentByIdApi, action.payload);
    yield put(fetchShipmentByIdSuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchShipmentByIdFailure, 'Failed to load shipment');
  }
}

function* saveShipmentSaga(action: PayloadAction<Partial<Shipment>>): Generator<any, void, any> {
  try {
    const response: Shipment = yield call(saveShipmentApi, action.payload);
    yield put(saveShipmentSuccess(response));
    toast.success('Shipment updated successfully');
  } catch (error: any) {
    yield handleSagaError(error, saveShipmentFailure, 'Failed to update shipment');
  }
}

function* shipShipmentSaga(action: PayloadAction<Partial<Shipment>>): Generator<any, void, any> {
  try {
    const response: Shipment = yield call(shipShipmentApi, action.payload);
    yield put(shipShipmentSuccess(response));
    toast.success('Shipment shipped successfully');
  } catch (error: any) {
    yield handleSagaError(error, shipShipmentFailure, 'Failed to ship shipment');
  }
}

export default function* shipmentsSaga() {
  yield takeLatest(fetchShipmentsRequest.type, fetchStoneShipmentsSaga);
  yield takeLatest(fetchShipmentByIdRequest.type, fetchShipmentByIdSaga);
  yield takeLatest(saveShipmentRequest.type, saveShipmentSaga);
  yield takeLatest(shipShipmentRequest.type, shipShipmentSaga);
}
